import type { ComponentProps } from "react"
import { forwardRef } from "react"

type Props = ComponentProps<"svg">

export const TrainIcon = forwardRef<SVGSVGElement, Props>((props, ref) => (
	<svg
		width="1em"
		height="1em"
		viewBox="0 0 16 16"
		xmlns="http://www.w3.org/2000/svg"
		ref={ref}
		{...props}
	>
		<path
			fill="currentColor"
			fillRule="evenodd"
			clipRule="evenodd"
			d="M5.32843 2C4.9306 2 4.54907 2.15804 4.26777 2.43934L3.85355 2.85355C3.65829 3.04882 3.34171 3.04882 3.14645 2.85355C2.95118 2.65829 2.95118 2.34171 3.14645 2.14645L3.56066 1.73223C4.0295 1.26339 4.66539 1 5.32843 1H10.6716C11.3346 1 11.9705 1.26339 12.4393 1.73223L12.8536 2.14645C13.0488 2.34171 13.0488 2.65829 12.8536 2.85355C12.6583 3.04882 12.3417 3.04882 12.1464 2.85355L11.7322 2.43934C11.4509 2.15804 11.0694 2 10.6716 2H9V3.00169C10.1649 3.00979 10.8313 3.05658 11.362 3.32698C11.9265 3.6146 12.3854 4.07354 12.673 4.63803C13 5.27976 13 6.11984 13 7.8V13.4342C13 13.4966 12.9557 13.5502 12.8945 13.5619C12.5534 13.6273 12.2114 13.6857 11.8687 13.7373L12.5 15H11L10.4553 13.9105C8.98183 14.0503 7.49942 14.064 6.02423 13.9515L5.5 15H4L4.59838 13.8032C4.09911 13.7374 3.60128 13.6569 3.10553 13.5619C3.04428 13.5502 3 13.4966 3 13.4342V7.8C3 6.11984 3 5.27976 3.32698 4.63803C3.6146 4.07354 4.07354 3.6146 4.63803 3.32698C5.24038 3.02007 6.01747 3.00123 7.5 3.00008V2H5.32843ZM9 11C9 11.5523 8.55228 12 8 12C7.44772 12 7 11.5523 7 11C7 10.4477 7.44772 10 8 10C8.55228 10 9 10.4477 9 11ZM5.5 4C4.67157 4 4 4.67157 4 5.5V9H5.5V4ZM12 5.5C12 4.67157 11.3284 4 10.5 4V9H12V5.5ZM9.5 4H6.5V9H9.5V4Z"
		></path>
	</svg>
))
